import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { withCampaignRateWindows } from './create-campaign-rate-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type CouponMetric =
    | 'couponsIssued'
    | 'couponsRedeemed'
    | 'issuedMembers'
    | 'redeemedMembers'
    | 'expiredCoupons'
    | 'couponRedemptionRate'
    | 'memberRedemptionRate';

/** Milestone ladder coupons. `couponsIssued`/`couponsRedeemed` duplicate
 * `campaign-coupons-issued`'s own scope-wide counts by design, kept equal by
 * an API-side test rather than a shared source.
 *
 * The two rate metrics cannot join the `trio` cards above them: a rate over
 * seven days is not a total divided by seven, so they read `rate-trio`
 * instead, three real windows via `withCampaignRateWindows`, composed
 * alongside (not instead of) the `trio` wrapper. */
const config: CampaignSourceConfig<CouponMetric> = {
    label: 'Campaign coupons',
    endpoint: 'analytics/campaign-coupons-member',
    metrics: [
        { id: 'couponsIssued', label: 'Coupons issued', type: 'scalar' },
        { id: 'couponsRedeemed', label: 'Coupons redeemed', type: 'scalar' },
        { id: 'issuedMembers', label: 'Issued members', type: 'scalar' },
        { id: 'redeemedMembers', label: 'Redeemed members', type: 'scalar' },
        { id: 'expiredCoupons', label: 'Expired coupons', type: 'scalar' },
        {
            id: 'couponRedemptionRate',
            label: 'Coupon redemption rate',
            type: 'ratio',
        },
        {
            id: 'memberRedemptionRate',
            label: 'Member redemption rate',
            type: 'ratio',
        },
    ],
    forms: ['trio', 'rate-trio'],
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
    percentMetrics: ['couponRedemptionRate', 'memberRedemptionRate'],
};

export const campaignCouponsMemberSource = withCampaignRateWindows(
    withCampaignWindows(createEnvelopeSource(config), config),
    config
);
